<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  /* @import './styles/new_file_mobile.css';
  @import './styles/result.css'; */

  #app{
    width: 100vw;
    
    position: relative;
    height: 276vw;
    background-image: url(./assets/pc.jpg);
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-color: rgb(171, 23, 19);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue